import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleColorMode',
  setup(__props) {

const colorMode = useColorMode()

const ariaLabel = computed(() => {
  const currentMode = colorMode.value
  const targetMode = currentMode === 'dark' ? 'light' : 'dark'
  return `Switch to ${targetMode} mode (currently ${currentMode})`
})

return (_ctx: any,_cache: any) => {
  return (_unref(colorMode))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "aria-label": _unref(ariaLabel),
        type: "button",
        class: "h-7 w-12 relative rounded-full bg-accent ml-2 items-center justify-start px-1 border-2 border-solid f-ring touch-action-manipulation border-muted/50 hover:border-muted active:border-muted motion-safe:transition-colors",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(colorMode).preference = _unref(colorMode).value === 'dark' ? 'light' : 'dark'))
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", {
          class: "inline-block rounded-full h-4 w-4 bg-primary light:translate-x-5 i-tabler:moon light:i-tabler:sun-high light:h-4 light:w-4 motion-safe:transition-transform",
          "aria-hidden": "true"
        }, null, -1)
      ]))], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})